import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  ContentServiceDetailSaveReqDTO,
  ContentServiceDetailSaveResDTO,
  ContentServiceDetailSearchReqDTO,
  ContentServiceDetailSearchResDTO,
  ContentServiceDetailUpdateReqDTO,
  ContentServiceDetailUpdateResDTO,
  UploadImageResDTO
} from 'src/models/Content';
import { tourismClassifiedAPIRoutes } from '../tourism-classified';

export const contentServiceDetail = createApi({
  reducerPath: 'contentServiceDetail',
  tagTypes: ['ContentServiceTag'],
  baseQuery: fetchBaseQuery({
    baseUrl: tourismClassifiedAPIRoutes.baseUrl,
    prepareHeaders: (headers) => {
      // If we have a token set in local storage, let's assume that we should be passing it.
      const token = localStorage.getItem('jwtToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    saveContent: builder.mutation<
      ContentServiceDetailSaveResDTO,
      ContentServiceDetailSaveReqDTO
    >({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.saveContent}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['ContentServiceTag']
    }),

    updateContent: builder.mutation<
      ContentServiceDetailUpdateResDTO,
      ContentServiceDetailUpdateReqDTO
    >({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.updateContent}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['ContentServiceTag']
    }),

    findContentBySearch: builder.query<
      ContentServiceDetailSearchResDTO,
      ContentServiceDetailSearchReqDTO
    >({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.findContentBySearch}`,
        method: 'POST',
        body
      }),
      providesTags: ['ContentServiceTag']
    }),

    getAllParentContentDetail: builder.query({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.getAllParentContentDetail}`,
        method: 'POST',
        body
      }),
      providesTags: ['ContentServiceTag']
    }),
    findContentBySearchMutation: builder.mutation<
      ContentServiceDetailSearchResDTO,
      ContentServiceDetailSearchReqDTO
    >({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.findContentBySearch}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['ContentServiceTag']
    }),

    findContentById: builder.mutation({
      query: (id) => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.findContentById}/${id}`,
        method: 'GET'
      }),
      invalidatesTags: ['ContentServiceTag']
    }),

    getContentMenuDetails: builder.mutation({
      query: () => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.getContentMenuDetails}`,
        method: 'GET'
      }),
      invalidatesTags: ['ContentServiceTag']
    }),

    deleteContent: builder.mutation({
      query: (body) => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.deleteContent}/${body.id}/${body.deleteType}`,
        method: 'DELETE',
        body
      }),
      invalidatesTags: ['ContentServiceTag']
    }),

    uploadImage: builder.mutation<
      UploadImageResDTO,
      {
        body: FormData;
      }
    >({
      query: ({ body }) => ({
        url: `${tourismClassifiedAPIRoutes.ContentController.endpoint}/${tourismClassifiedAPIRoutes.ContentController.uploadImage}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['ContentServiceTag']
    })
  })
});
export const {
  useDeleteContentMutation,
  useFindContentByIdMutation,
  useFindContentBySearchMutationMutation,
  useFindContentBySearchQuery,
  useSaveContentMutation,
  useUpdateContentMutation,
  useUploadImageMutation,
  useGetAllParentContentDetailQuery,
  useGetContentMenuDetailsMutation
} = contentServiceDetail;
